import { createAction } from '@reduxjs/toolkit'

export const apiCallInitialized = createAction<string>('api/callInitialized')
export const apiCallSuccess = createAction<string>('api/callSuccess')
export const apiCallFailed = createAction<string>('api/callFailed')
